export const removeStringDuplicates = (...stringArray: string[]): string[] => Array.from(new Set(stringArray.flat()));
